<div class="d-flex" [ngClass]="{ 'col-363636': isAcmic }">
    <div>
        <img 
            *ngIf="!isAcmic"
            src="{{policy?.displayType?.icon}}" 
            class="margin-right mr12" 
            width="32" height="32" 
            alt="{{policy?.policyType?.toLowerCase()}} icon" 
        />

        <img 
            *ngIf="isAcmic"
            src="{{policy?.displayType?.icon}}" 
            class="margin-right mr16" 
            width="32" height="32" 
            alt="{{policy?.policyType?.toLowerCase()}} icon" 
        />        
    </div> 
    <div class="policy-type-num-term-container" [ngClass]="{ 'acmic-lineheight': isAcmic }">
        <div class="nowrap">
            {{ policy?.displayType?.label | translate }} &ndash; {{ policy?.policynumber.policyNumber }}        
        </div>
        <div class="term-col" 
            [ngClass]="{ 'dash-red-color': !(policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE') }">
            {{ policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE' 
            ? ""
            : policy?.policyStatus | translate | titlecase }} 
            
            {{ policy?.effDate | customDateFormat }} 
            <ng-container *ngIf="isAcmic; else nonAcmicTxt">-</ng-container>
            <ng-template #nonAcmicTxt>
                {{ 'TO' | translate }}
            </ng-template>
            {{ policy?.expDate | customDateFormat }}
        </div>
    </div>
</div>
